import TrafficLight from './TrafficLight';

export default TrafficLight;
